module.exports = __webpack_public_path__ + "img/api-loading.3f0d484.webp";